function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import React, { useContext } from "react";
import { CarinaContext } from "../../CarinaProvider";
var buildStyle = function(param) {
    var animation = param.animation, backgroundColor = param.backgroundColor, borderColor = param.borderColor, colors = param.colors, size = param.size;
    var ref;
    var ref1 = (animation === null || animation === void 0 ? void 0 : (ref = animation.productive) === null || ref === void 0 ? void 0 : ref.easeInOut) || {}, easing = ref1.easing, duration = ref1.duration;
    var medium = (duration || {}).medium;
    return {
        dot: {
            base: {
                borderRadius: size.border.radius.round,
                width: 16,
                height: 16,
                background: colors.neutral[45],
                scale: 0.75,
                position: 'absolute',
                transformOrigin: '50% 50%',
                transition: "transform ".concat(medium, " ").concat(easing, ", opacity ").concat(medium, " ").concat(easing, ", box-shadow ").concat(animation.duration[100], " ").concat(easing),
                cursor: 'pointer',
                border: 'none',
                margin: 0,
                padding: 0,
                textDecoration: 'none'
            },
            active: {
                background: backgroundColor.neutral.surface,
                scale: 1,
                cursor: 'default',
                '.js-focus-visible :focus > &': {
                    boxShadow: "0 0 0 2px ".concat(borderColor.interactive.focus)
                },
                '.js-focus-visible :focus:not(.focus-visible) > &': {
                    boxShadow: 'none'
                }
            },
            reducedMotion: {
                transitionProperty: 'none'
            },
            secondary: {
                scale: 0.75
            },
            more: {
                scale: 0.5
            },
            furthermore: {
                scale: 0.25
            },
            hidden: {
                opacity: 0,
                scale: 0
            },
            dotSize: {
                m: {
                    width: 12,
                    height: 12
                },
                l: {
                    width: 16,
                    height: 16
                }
            }
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl, variant = param.variant, dotSize = param.dotSize, position = param.position;
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle || !builtStyle.dot) {
        return {
            dot: {}
        };
    }
    var dot = builtStyle.dot;
    var rtlMultiplier = isRtl ? -1 : 1;
    var pixelPaddingMultiplier = dotSize === 'm' ? 20 : 24;
    return {
        dot: _objectSpread({}, dot.base, dot.dotSize[dotSize], dot[variant], {
            scale: undefined,
            transform: "translateX(".concat(rtlMultiplier * position * pixelPaddingMultiplier, "px) scale(").concat(dot[variant].scale, ") ")
        }, prefersReducedMotion && dot.reducedMotion)
    };
};
export default useStyle;
